module.exports = __webpack_public_path__ + "static/media/curriculum_bg_blur.d429f0f6.png";